import { Typography } from '@mui/material';

export const Screen2Disclaimer = () => {
  return (
    <div className="p-6 ">
      <Typography variant="h3" textAlign="center" mb={2}>
        Disclaimer
      </Typography>
      <Typography fontSize={21}>
        The information provided on this app is for guiding conversations with your customers and is informational purposes only. Amazon
        assumes no responsibility for errors or omissions in the content or for any actions taken based on the information provided. Amazon
        is not responsible for the accuracy, reliability, or content of the information presented herein. Use of this app is at your own
        risk, and Amazon is not liable for any damages arising from its use.
      </Typography>
    </div>
  );
};
